<template lang="pug">
  .box
    .blockOne
      .oneHeader
        h3 产品概述
        .blue
      .oneBody
        img(src="../../assets/images/partybuiling/e1.jpg" alt="")
        .pBox
          p <span>速云党建管理系统</span>是通过对党员管理，初步构建“党务管理智能化、信息管理维护精准化、党员教育管理个性化”的智慧工作新模式，减少人员工作量，提高办公效率，打破了地域、时空界限的壁垒，实现党建信息数据的完全对接、融合及提取，并通过线上线下的结合，构建党建工作的数字化和智能化。
    .blockTwo
      .twoHeader
        h3 痛点分析
        .blue
      .twoBody
        ul(style="margin-left:30px;")
          li
            .yuan 01
            .pBox
              h3 党员集中难
              p 党组织多，地域分散，如何由集中性教育变成常态化教育是一大难题
          li
            .yuan 02
            .pBox
              h3 时间保证难
              p 机关党员以工作为由，不按照要求到社区报到参加党员志愿服务活动，参与学习教育的数量和质量都很难保证
          li
            .yuan 03
            .pBox
              h3 学习落实难
              p 党组织党内政治生活制度不落实，“三会一课”制度停留在记录上，党内活动流于形式化，表面化，娱乐化
          li
            .yuan 04
            .pBox
              h3 党费收缴难
              p 党费计算工作量较大，容易出错，流动党员收缴党费难落实
        .line
        ul(style="float:right;margin-right:30px;")
          li
            .yuan 05
            .pBox
              h3 党性意识培养难
              p 党员党性意识淡薄，长期不参加组织生活，不按时缴纳党费，游离于日常监管之外，党员最基本的义务都不能履行
          li
            .yuan 06
            .pBox
              h3 党员发展规范难
              p 党组织多，地域分散，如何由集中性教育变成常态化教育是一大难题
          li
            .yuan 07
            .pBox
              h3 党建统计管理难
              p 城市经济社会结构的变化，形成了不少党建工作的“真空地带”，统计工作开展不顺畅，需要投入大量人力物力
          li
            .yuan 08
            .pBox
              h3 台账汇总追溯难
              p 党员台账较多，保存和查看是个问题，做不到履职留痕
    .blockOne
      .oneHeader
        h3 产品功能
        .blue
      .oneBody
        .one
          h3 一、初心与使命
          .nei
            h3 1. 调查调研
            img(src="../../assets/images/partybuiling/e2.png" alt="")
          .neiTwo
            h3 2. 检视问题
            .nrBox
              p 支持栏目分类，支持内容上传（可添加附件）。
              p 支持查看评论数、查看已读未读。
              p 支持二次提醒未读人员，支持预览。
              p 支持重要内容置顶。
              p 支持资讯直接分享。
              p 会议活动的召开。
            img(src="../../assets/images/partybuiling/e3.png" alt="")
        .one
          h3 二、咨讯管理
          .neiTwo
            h3 1. 通知公告消息必达
            .nrBox(style="margin: 0 40px;")
              p 支持指定范围发送通知公告，公告内容支持上传附件。
              p 支持查看评论，支持查看已读未读。
              p 支持给未读人员发送提醒。
              p 支持内容预览、支持重要通知置顶。
            img(src="../../assets/images/partybuiling/e4.png" alt="" style="width:40%;border:1px solid red;")
        .one
          h3 三、学习教育
          .neiTwo
            h3 1. 党员的在线学习平台
            .nrBox(style="margin: 0 40px;")
              p 支持在线选课。
              p 将党员的教育融入日常，抓在经常。
              p 自主选择课程，实时记录学习进度。
              p 支持发布图文、视频、外链。
              p 支持查看评论、已读未读、支持二次提醒未读人员，支持预览，支持重要课件置顶。
            img(src="../../assets/images/partybuiling/e5.png" alt="" style="width:22%;border:1px solid red;")
        .one
          h3 四、组织活动
          .neiTwo
            h3 1. 组织活动高效便捷
            .nrBox(style="margin: 0 40px;")
              p 党内活动的发布和报名平台，实时统计报名数据，高效省时。
              p 支持活动分类、支持附件上传，支持活动发布日期任意选择。
              p 支持活动发起范围选择，支持导出活动历史列表。
            img(src="../../assets/images/partybuiling/e6.png" alt="" style="width:35%;border:1px solid red;")
        .one
          h3 五、党务工作
          .neiTwo
            h3 1. 选举公正 公开透明 把好换届“关”
            .nrBox(style="margin: 0 40px;")
              p 党支部可通过线上操作为每位党员都准备完整的会议材料。党支部可在云端网络，就上届支委的工作情况、换届选举筹备工作情况，向与会党员作出报告。通过线上无记名投票、电子公开计票的方法，差额选举出新一届委员。
            img(src="../../assets/images/partybuiling/e7.png" alt="" style="width:18%;border:1px solid red;")
        .one
          h3 五、纪检工作
          .neiTwo
            .nrBox(style="margin: 0 40px;")
              p 在线组织纪检人员，筹备纪检会议，组织纪检学习、廉洁约谈，布署任务计划、纪检任务，收集意见建议，管理监督执纪等。
            img(src="../../assets/images/partybuiling/e8.png" alt="" style="width:18%;border:1px solid red;")
    .blockTwo(style="background-color: #f2f2f2;margin-bottom:0;")
      .twoHeader
        h3 产品价值
        .blue
      .threeBody
        img.img(src="../../assets/images/canteen/c9.png" alt="")
        p.up 通过线上线下的结合，构建党建工作的数字化和智能化。
        p.left 通过网上向群众和社会提供在线志愿服务，发挥出党员在网络中的积极作用。
        p.bottom 通过实时感知、在线提交、快速动员等实现了对基层党建团建的动态跟踪和针对性管理服务。
        p.right 通过量化计分、实时智能分析、自动提醒服务等实现了党建团建管理的精确化、智能化、人文化和科学化。
</template>

<script>
export default {
  data () {
    return {}
  },
  created () {
    this.$store.commit('changeNavOther', 6)
  }
}
</script>

<style lang="less" scoped>
  .blockOne{
    width: 70%;
    margin: 0 auto 68px;
    .oneHeader{
      font-size: 20px;
      padding-bottom: 30px;
      h3{
        font-weight: 400;
      }
      .blue{
        float: left;
        width: 35px;
        height: 3px;
        background-color: #409fee;
        margin-top: 10px;
      }
    }
    .oneBody{
      text-align: justify;
      overflow: hidden;
      img{
        float: right;
        width: 40%;
        vertical-align: middle;
      }
      .pBox{
        float: left;
        width: 50%;
        border-radius: 10px;
        border: 2px solid red;
        padding: 10px;
        margin-top: 30px;
        p{
          line-height: 26px;
          text-indent: 2em;
          span{
            font-size: 20px;
            color: red;
          }
        }
      }
      .one{
        h3{
          font-weight: 400;
          font-size: 18px;
          margin: 10px 0;
        }
        .nei{
          h3{
            font-size: 16px;
            margin-left: 20px;
          }
          img{
            display: block;
            float: none;
            width: 70%;
            margin: 0 auto;
          }
        }
        .neiTwo{
          overflow: hidden;
          h3{
            font-size: 16px;
            margin-left: 20px;
          }
          .nrBox{
            float: left;
            width: 38%;
            line-height: 26px;
            margin: 60px 100px;
            border: 1px solid red;
            border-radius: 10px;
            padding: 20px;
          }
          img{
            width: 20%;
            float: left;
          }
        }
      }
    }
  }
  .blockTwo{
    padding: 0 15% 20px;
    background-color: #f9f9f9;
    margin-bottom: 20px;
    .twoHeader{
      font-size: 20px;
      padding: 30px 0;
      h3{
        font-weight: 400;
        text-align: right;
      }
      .blue{
        float: right;
        width: 35px;
        height: 3px;
        background-color: #409fee;
        margin-top: 10px;
      }
    }
    .twoBody{
      overflow: hidden;
      ul{
        width: 40%;
        float: left;
        li{
          overflow: hidden;
          height: 102px;
          margin-bottom: 10px;
          .yuan{
            width: 60px;
            height: 60px;
            line-height: 60px;
            float: left;
            text-align: center;
            background-color: red;
            border-radius: 30px;
            color: #fff;
            font-weight: 900;
            font-size: 30px;
            margin-top: 5px;
          }
          .pBox{
            float: left;
            width: 80%;
            margin-left: 10px;
            h3{
              margin-bottom: 5px;
            }
            p{
              font-size: 14px;
              line-height: 24px;
            }
          }
        }
      }
      .line{
        float: left;
        width: 1px;
        height: 438px;
        background-color: #ccc;
        margin-left: 58px;
      }
    }
    .threeBody{
      height: 300px;
      position: relative;
      img{
        float: left;
        width: 35%;
        height: 300px;
      }
      .pBox{
        float: right;
        width: 50%;
        background-image: url(../../assets/images/platform/bc1.jpg);
        background-size: cover;
        padding: 80px 66px 20px;
        text-align: justify;
        line-height: 26px;
      }
      .img{
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 50%;
      }
      .up,.left,.bottom,.right{
        position: absolute;
        width: 25%;
        text-indent: 2em;
      }
      .up{
        top: 45px;
        left: 0px;
      }
      .left{
        top: 26px;
        right: 0px;
      }
      .bottom{
        bottom: 32px;
        left: 0px;
      }
      .right{
        bottom: 33px;
        right: 0px;
      }
    }
  }
</style>
